import React, { useState, useEffect } from 'react';
import {
  Box,
  Chip,
  Tooltip,
} from '@mui/material';
import {
  AccessTime,
} from '@mui/icons-material';

const SessionIndicator: React.FC = () => {
  const [currentTime, setCurrentTime] = useState<string>('');

  useEffect(() => {
    const updateCurrentTime = () => {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      setCurrentTime(`${hours}:${minutes}`);
    };

    updateCurrentTime();
    const interval = setInterval(updateCurrentTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title="Current Time">
        <Chip
          icon={<AccessTime />}
          label={currentTime}
          color="success"
          size="small"
          sx={{ cursor: 'default' }}
        />
      </Tooltip>
    </Box>
  );
};

export default SessionIndicator;
